var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.275 12.5116L6.925 5.16163C6.675 4.91163 6.554 4.61996 6.562 4.28663C6.57 3.95329 6.69933 3.66163 6.95 3.41163C7.20067 3.16163 7.49234 3.03663 7.825 3.03663C8.15767 3.03663 8.44933 3.16163 8.7 3.41163L16.4 11.0866C16.6 11.2866 16.75 11.5116 16.85 11.7616C16.95 12.0116 17 12.2616 17 12.5116C17 12.7616 16.95 13.0116 16.85 13.2616C16.75 13.5116 16.6 13.7366 16.4 13.9366L8.7 21.6366C8.45 21.8866 8.154 22.0076 7.812 21.9996C7.47 21.9916 7.17433 21.8623 6.925 21.6116C6.67567 21.361 6.55067 21.0693 6.55 20.7366C6.54933 20.404 6.67433 20.1123 6.925 19.8616L14.275 12.5116Z",
    fill: "#C1D8EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonArrow);
export default __webpack_public_path__ + "static/media/button-arrow.92a0251c672d59daa3d5f57e51b0bc8d.svg";
export { ForwardRef as ReactComponent };